/* Geschenkverpackung auf den übrigen Schildern (Luis 04.11.2026), Karte aus snippets/sm-pdp-tuete.liquid auf den Wegen ohne und direkt; Produkte mit
   Gestalter haben sie in assets/sm-zunft-gestalter.js (Teil 7). Größe nach der gewählten Variante wie im Warenkorb (snippets/sm-cart-extras.liquid,
   bagNeed in assets/sm-rewards.js): bis 22,5 cm klein, bis 55 cm groß, darüber keiner, ohne Größe groß. Nach dem Kauf (Weg direkt: Ereignis smp:warenkorb
   aus sm-pdp.js, Weg ohne: cartUpdate aus product-form.js) kommt der Beutel mit einer eigenen Anfrage dazu, wenn noch keiner im Warenkorb liegt; danach
   zeichnet die Schublade ihre Artikel neu, ohne sich zu öffnen, und sm-rewards.js hält die Größe. */
(function(){
  'use strict';
  const K = document.querySelector('[data-smt]'), R = K && K.closest('[data-sm-pdp]');
  if (!R) return;
  let B, C;
  try { B = JSON.parse(K.querySelector('[data-smt-cfg]').textContent); C = JSON.parse(R.querySelector('[data-smp-cfg]').textContent); } catch (e) { return; }
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/', FMT = new Intl.NumberFormat('de-DE', { style: 'currency', currency: C.geld || 'EUR' });
  const TXT = K.querySelector('[data-smt-text]'), alle = [B.k, B.g].filter(Boolean).map(x => x.id);
  const cmOf = s => parseFloat(String(s).split('cm')[0].split('x')[0].replace(',', '.').trim()) || 0;
  function variante(){
    const i = R.querySelector('[data-smp-form] input[name="id"]') || R.querySelector('form[action*="/cart/add"] input[name="id"]'), id = i ? +i.value : C.variante;
    return (C.varianten || []).filter(v => v.id === id)[0];
  }
  function beutel(){
    const v = variante(); let cm = 0;
    ((v && v.options) || []).forEach(o => { if (String(o).indexOf('cm') >= 0) cm = cmOf(o); });
    if (cm > 55) return null;
    const x = cm > 0 && cm <= 22.5 ? B.k : B.g;
    return x ? Object.assign({ gr: x === B.k ? 'klein' : 'groß' }, x) : null;
  }
  let an = false, b = null;
  function lage(){
    b = beutel(); K.hidden = !b;
    if (!b) an = false;
    K.querySelectorAll('[data-smt-w]').forEach(x => x.setAttribute('aria-pressed', String(!!x.dataset.smtW === an)));
    if (b) TXT.textContent = 'Schwarzer Satinbeutel, ' + b.gr + ' · + ' + FMT.format(b.p / 100);
  }
  K.addEventListener('click', e => {
    const x = e.target.closest('[data-smt-w]'); if (!x || !!x.dataset.smtW === an) return;
    an = !!x.dataset.smtW; lage();
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'sm_gift_wrap', sm_on: an, sm_size: b ? b.gr : '', sm_ort: 'produktseite' }); } catch (e2) {}
  });
  R.addEventListener('change', () => setTimeout(lage, 80));
  lage();

  let laeuft = false;
  function dazu(){
    if (!an || !b || laeuft) return;
    const t = b; laeuft = true;
    fetch(ROOT + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(r => r.json()).then(c => {
      if (c.items.some(i => alle.indexOf(i.variant_id) >= 0)) return null;   // ein Beutel je Bestellung
      return fetch(ROOT + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: t.id, quantity: 1 }], sections: 'cart-icon-bubble', sections_url: location.pathname }) })
        .then(r => r.json()).then(j => {
          if (j.status) return;
          try {
            const bub = document.getElementById('cart-icon-bubble'), s = j.sections && j.sections['cart-icon-bubble'];
            if (bub && s){ const d = new DOMParser().parseFromString(s, 'text/html').querySelector('.shopify-section'); if (d) bub.innerHTML = d.innerHTML; }
          } catch (e) {}
          const di = document.querySelector('cart-drawer-items'); if (di && typeof di.onCartUpdate === 'function') di.onCartUpdate();
          try { document.dispatchEvent(new CustomEvent('sm:cart-changed')); } catch (e) {}
        });
    }).catch(() => {}).then(() => { laeuft = false; });
  }
  addEventListener('smp:warenkorb', dazu);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, e => { if (e && e.source === 'product-form') dazu(); });
})();
